import React from 'react';
import SimpleReportForm from '../SimpleReportForm';
import GenericSurepassOutputComponent from '../output/GenericSurepassOutputComponent';

const UdyamOtpSubmitInputComponent = () => (
    <SimpleReportForm
        banner={{ icon: 'pi-check-circle', title: 'Udyam OTP Submit', subtitle: 'Verify the OTP received during Udyam (MSME) registration verification' }}
        fields={[
            { name: 'client_id', label: 'Client ID', icon: 'pi-key', placeholder: 'udyam_xxxxxxxxxxxxx', maxLength: 100, mono: true },
            { name: 'otp', label: 'OTP', icon: 'pi-lock', placeholder: '6-digit OTP', maxLength: 6, inputMode: 'numeric', numeric: true, autoComplete: 'one-time-code', mono: true,
              regex: /^\d{4,8}$/, regexError: 'Enter a valid OTP', colClass: 'col-12 md:col-4' },
        ]}
        endpoint={{
            path: '/surepass/udyam-otp/submit-otp',
            bodyMapper: (v, sid) => ({ client_id: v.client_id.trim(), otp: v.otp, api_provider_service_id: parseInt(sid, 10) }),
        }}
        consentReportType="udyam-otp-submit"
        submitLabel="Verify OTP"
        successSummary="Udyam OTP verified"
        errorSummary="OTP verification failed"
        confirmHeader="Confirm Udyam OTP verification"
        confirmAcceptLabel="Yes, verify"
        outputComponent={GenericSurepassOutputComponent}
        outputProps={{ title: 'Udyam Verified', icon: 'pi-check-circle' }}
    />
);

export default UdyamOtpSubmitInputComponent;
